module.exports = __webpack_public_path__ + "static/media/Scrape.svg";